// Modal potwierdzenia odrzucenia oferty z polem na powód widoczny dla handlowca.

import React, { type FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, CircularProgress, TextField } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CancelIcon from '@mui/icons-material/Cancel';

import { WiseModal } from 'components/wise';

interface IProps {
  open: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
}

const RejectOfferModal: FC<IProps> = ({ open, isSubmitting, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  return (
    <WiseModal
      open={open}
      onClose={onClose}
      title={t('Czy na pewno chcesz odrzucić ofertę?')}
      maxWidth={520}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, padding: 4 }}>
        <div
          style={{
            display: 'flex',
            gap: 10,
            padding: 12,
            background: '#f1eeff',
            borderRadius: 8,
            color: '#3d2fb8',
            fontSize: 13,
            lineHeight: 1.5
          }}>
          <InfoOutlinedIcon style={{ fontSize: 18, marginTop: 1, flexShrink: 0 }} />
          <div>
            {t(
              'Napisz handlowcowi dlaczego odrzucasz ofertę. Twoja wiadomość zostanie zapisana jako komentarz i będzie widoczna dla handlowca.'
            )}
          </div>
        </div>

        <TextField
          label={t('Powód odrzucenia')}
          placeholder={t('Np. cena za wysoka, nie pasuje termin dostawy, zmieniła się sytuacja...')}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          minRows={4}
          fullWidth
          autoFocus
          helperText={t('Pole opcjonalne, ale zalecane - pomoże handlowcowi przygotować lepszą ofertę następnym razem.')}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={onClose} variant="text" disabled={isSubmitting}>
            {t('Anuluj')}
          </Button>
          <Button
            onClick={() => onSubmit(reason.trim())}
            variant="contained"
            disabled={isSubmitting}
            startIcon={<CancelIcon />}
            sx={{
              backgroundColor: '#e02e4e',
              fontWeight: 600,
              '&:hover': { backgroundColor: '#c01a3a' }
            }}>
            {isSubmitting ? <CircularProgress size={18} /> : t('Odrzuć ofertę')}
          </Button>
        </div>
      </div>
    </WiseModal>
  );
};

export default RejectOfferModal;
